import type { FlowOwnership } from '@interfaces/IFlowView';
import { CheckCircleIcon, UsersIcon } from '@utils/icons';
import styles from './Ownership.module.css';

type IOwnershipProps = {
  title: string;
  meta: string;
  rows: FlowOwnership[];
};

export function Ownership({ title, meta, rows }: IOwnershipProps) {
  return (
    <section className={styles.panel}>
      <header className={styles.head}>
        <div className={styles.heading}>
          <UsersIcon size={14} />
          <h2 className={styles.title}>{title}</h2>
          <span className={styles.meta}>· {meta}</span>
        </div>
      </header>

      <div className={styles.grid}>
        {rows.map((row) => (
          <div key={row.key} className={styles.card} data-status={row.status}>
            <div className={styles.cardHead}>
              <span className={styles.dot} aria-hidden />
              <span className={styles.stage}>{row.stage}</span>
            </div>
            <span className={styles.owner}>{row.owner}</span>
            <span className={styles.doneRow}>
              <CheckCircleIcon size={12} />
              {row.doneLabel}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
